import { API, standardResponse } from "./middleware";

export async function getAttachmentByObject(objectId, objectType) {
  const url = `/api/attachments/getByObjectId?objectId=${objectId}&objectType=${objectType}`;
  return API.get(url)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function getImageUrl(url) {
  try {
    const response = await API.get(url, {
      responseType: "blob",
    });

    const blob = response.data;
    const objectUrl = URL.createObjectURL(blob);
    return objectUrl;
  } catch (error) {
    return standardResponse(false, error.response?.data);
  }
}

export async function uploadFile(file) {
  const url = "/api/attachments/upload";
  const formData = new FormData();
  formData.append("file", file); // Đúng với @RequestParam("file") trong backend

  return API.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Quan trọng khi gửi FormData
    },
  })
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function downloadAllFiles(attachmentIds) {
  if (!Array.isArray(attachmentIds) || attachmentIds.length === 0) {
    alert("Không có file nào để tải.");
    return;
  }

  try {
    const response = await API.post(
      "/api/attachments/downloadZip",
      attachmentIds,
      { responseType: "blob" } // Quan trọng để tải file nhị phân
    );

    const blob = response.data;
    const url = window.URL.createObjectURL(blob);

    // Lấy tên file từ header
    const disposition = response.headers["content-disposition"];
    const match = disposition?.match(/filename="?([^"]+)"?/);
    const filename = match?.[1] || "attachments.zip";

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Lỗi tải file:", error);
    alert("Không thể tải file.");
  }
}

export async function downloadExcelFile(encodedProjectId) {
  const url = `api/project/download/excel/${encodedProjectId}`;
  return API.get(url, { responseType: "blob" })
    .then((response) => {
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        return { success: true, blob };
      }
      return { success: false, blob: null };
    })
    .catch((error) => ({ success: false, message: error.message }));
}

export const getImageUrlSigned = (attachment, useWebp = true) => {
  if (!attachment) return null;
  const token = useWebp ? attachment.signedTokenWebp : attachment.signedTokenOriginal;
  return token ? `${API.defaults.baseURL}/api/attachments/downloadSigned?token=${token}` : null;
};

export const getImageUrlSignedPublic = (attachment, useWebp = true) => {
  if (!attachment) return null;
  const token = useWebp ? attachment.signedTokenWebp : attachment.signedTokenOriginal;
  return token
    ? `${API.defaults.baseURL}/api/public/attachments/downloadSigned?token=${token}`
    : null;
};
